module.exports = __webpack_public_path__ + "img/YJCZ_ACT.982c7802.png";